/**
 * L2-R7: the pipe moved to @miq/platform-ui (lib/pipes/data-cell-formatter.pipe.ts). This file used
 * to re-export `../../../pipe/data-cell-formatter.pipe`; it now forwards straight to the library so
 * the second-hop shim does not drag @shared back into library consumers. New code should import
 * from '@miq/platform-ui'.
 */
export { DataCellFormatterPipe, dateSanitizer } from '@miq/platform-ui';
